/**
 * Avatar configuration: the player character GLB + Mixamo animation track names
 * and placement corrections.
 *
 * The GLB is produced offline by heroblender/mixamo_glb_merger: Idle/Walking/
 * Run/Jump are baked into a single player.glb so the runtime loads one asset.
 * `avatarRotationOffset` corrects a model that faces the wrong way (Mixamo
 * characters typically face +Z; if the controller's forward is -Z, set 180).
 * `eyeHeight` must match CharacterController.eyeHeight. `groundOffset` mirrors
 * CharacterController.hoverHeight so the visible model is placed at the ground
 * while the collision capsule keeps its small hover clearance.
 */

export interface AvatarConfig {
    /** Runtime URL of the baked player.glb. */
    avatarUrl: string;
    /** Anim track names inside the GLB (state → track). */
    idleAnim: string;
    walkAnim: string;
    runAnim: string;
    jumpAnim: string;
    /** Extra one-shot action clips exposed as HUD buttons. */
    actionAnims: ReadonlyArray<{ name: string; label: string; duration?: number; loop?: boolean }>;
    /** Uniform scale applied to the model. */
    avatarScale: number;
    /** Yaw correction in degrees (model forward vs. world forward). */
    avatarRotationOffset: number;
    /** Eye height — matches CharacterController.eyeHeight for feet placement. */
    eyeHeight: number;
    /** Extra visual downward offset matching CharacterController.hoverHeight. */
    groundOffset: number;
}

export const avatarConfig: AvatarConfig = {
    avatarUrl: '/assets/avatars/man/player.glb',
    idleAnim: 'Idle',
    walkAnim: 'Walking',
    runAnim: 'Run',
    jumpAnim: 'Jump',
    actionAnims: [
        { name: 'Goodbye', label: '再见' },
        { name: 'HandRaising', label: '举手' },
        { name: 'Waving', label: '挥手' },
        { name: 'Clap', label: '鼓掌' },
        { name: 'Cheering', label: '欢呼' },
        { name: 'Dancing', label: '跳舞' },
        { name: 'Kneel', label: '跪下' }
    ],
    avatarScale: 1,
    avatarRotationOffset: 0,
    eyeHeight: 1.3,
    groundOffset: 0.2
};
